module.exports = __webpack_public_path__ + "img/pic1.4c9de116.png";